import { Box, SwipeableDrawer, styled } from '@mui/material';
import { inferiorDrawerBleeding } from './InferiorMenuDrawer';

const pullerWidth = 30;

export const PullerWrapper = styled(Box)(() => ({
  position: 'absolute',
  top: -inferiorDrawerBleeding,
  visibility: 'visible',
  right: 4,
  left: 4
}));

export const Puller = styled(Box)(({ theme }) => ({
  width: pullerWidth,
  height: 6,
  backgroundColor: theme.inferiorMenu.pullerBg,
  borderRadius: 3,
  position: 'absolute',
  top: 0,
  left: `calc(50% - ${pullerWidth / 2}px)`
}));

export const SwipeableWrapper = styled(SwipeableDrawer)(() => ({
  '.MuiPaper-root': {
    overflowY: 'visible',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10
  }
}));
